module.exports = __webpack_public_path__ + "img/spjgcxc.c1dd0570.png";